const state = {
  title: '',
  message: '',
  show: false,
  callback: () => {}
}

const getters = {
  getDialog: state => state
}

const actions = {
  showDialog ({ state }, info) {
    const { title, message = '', callback = () => {}, buttonLabel, buttonColor, buttonClass, removeCancel, lists, messageClass, titleClass, dialogWidth } = info
    state.message = message
    state.messageClass = messageClass
    state.title = title
    state.titleClass = titleClass
    state.callback = callback
    state.buttonLabel = buttonLabel
    state.buttonColor = buttonColor
    state.buttonClass = buttonClass
    state.removeCancel = removeCancel
    state.dialogWidth = dialogWidth
    state.lists = lists
    state.show = true
  }
}

export default {
  state,
  actions,
  getters
}
